// Global country list for the Flex/Remote marketplace (city + country).
export const COUNTRIES = [
  "United States", "Canada", "United Kingdom", "Ireland", "Australia", "New Zealand",
  "Germany", "France", "Spain", "Portugal", "Italy", "Netherlands", "Belgium", "Switzerland",
  "Austria", "Sweden", "Norway", "Denmark", "Finland", "Poland", "Czech Republic", "Romania",
  "Greece", "Turkey", "Ukraine", "Russia",
  "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman", "Israel",
  "India", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal", "Philippines", "Indonesia",
  "Malaysia", "Singapore", "Thailand", "Vietnam", "China", "Hong Kong", "Japan", "South Korea",
  "South Africa", "Nigeria", "Kenya", "Ghana", "Egypt", "Morocco", "Ethiopia",
  "Brazil", "Mexico", "Argentina", "Colombia", "Chile", "Peru",
  "Other",
];
